import * as z from "zod";

export const alcatrazRequestIntents = ["trial", "trial_demo", "access", "access_demo"] as const;
export type AlcatrazRequestIntent = (typeof alcatrazRequestIntents)[number];

export const alcatrazRequestSchema = z.object({
  name: z.string().trim().min(2).max(100),
  company: z.string().trim().min(2).max(150),
  email: z.string().trim().email().max(200),
  phone: z.string().trim().min(5).max(50),
  intent: z.enum(alcatrazRequestIntents),
  needsSample: z.boolean().optional().default(false),
  consent: z.literal(true),
  source: z.string().trim().min(1).max(80),
});

export const alcatrazRequestBodySchema = alcatrazRequestSchema.extend({
  website: z.string().max(200).optional().default(""),
});

export type AlcatrazRequest = z.infer<typeof alcatrazRequestSchema>;
export type AlcatrazRequestBody = z.infer<typeof alcatrazRequestBodySchema>;
